if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.successTimeout = null;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.resetSuccessState();
        this.handleErrorMessage();
        this.error = false;
        this.addedToCart = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.addedToCart = true;
            this.error = false;
            this.updateCartBubble();

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            if (this.addedToCart) {
              this.showSuccessState();
            } else {
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            }

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      showSuccessState() {
        const spinner = this.querySelector('.loading__spinner');

        this.submitButton.classList.add('cleq-added');
        spinner?.classList.remove('hidden');

        this.successTimeout = setTimeout(() => {
          this.submitButton.classList.remove('cleq-added');
          spinner?.classList.add('hidden');
        }, 1400);
      }

      resetSuccessState() {
        if (this.successTimeout) {
          clearTimeout(this.successTimeout);
          this.successTimeout = null;
        }

        this.submitButton.classList.remove('cleq-added');
      }

      updateCartBubble() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (!cartIcon) return;

            cartIcon.classList.toggle('is-empty', cart.item_count < 1);

            let bubble = cartIcon.querySelector('.cart-count-bubble');

            if (cart.item_count < 1) {
              bubble?.remove();
              return;
            }

            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              cartIcon.appendChild(bubble);
            }

            bubble.innerHTML = `
              ${cart.item_count < 100 ? `<span aria-hidden="true">${cart.item_count}</span>` : ''}
              <span class="visually-hidden">${cart.item_count} Artikel im Warenkorb</span>
            `;

            document.querySelectorAll('.cleq-header-cart-subtotal').forEach((subtotal) => {
              subtotal.textContent = this.formatMoney(cart.total_price);
            });
          })
          .catch((e) => {
            console.error(e);
          });
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'EUR';
        const locale = document.documentElement.lang || 'de-DE';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch (e) {
          return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
